import angular from 'angular';
import taskListComponent from './task-list.component';
import taskListService from './task-list.service';
import taskListConfig from './task-list.config';

let taskListModule = angular.module('app.taskList',[])
  .component('taskList', taskListComponent)
  .service('taskListService', taskListService)
  .config(taskListConfig);

export default taskListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/task-list/task-list.js
 **/